
import { onlineUrl } from '@/utils/config';
// 企业管理
export default {
  path: "/cost-center",
  name: "const-center",
  component: () => import("@/views/cost-center/index.vue"),
  meta: {
    title: '企业管理',
    icon: 'icon-qiyeguanli1'
  },
  children: [
    // 企业信息
    {
      path: `${onlineUrl}/purchase-order/supplier/administration/administration-info`,
      name: "administrationInfo",
      meta: {
        title: "企业信息",
        isExternal: true,
      },
    },
    // 账号安全
    {
      path: `${onlineUrl}/purchase-order/supplier/administration/account-info`,
      name: "accountInfo",
      meta: {
        title: "账号安全",
        isExternal: true,
      },
    },
    {
      path: `${onlineUrl}/supplier-profile`,
      name: 'supplier-profile',
      component: ()=> import('@/views/otherUrlView.vue'),
      meta: {
        title: '企业档案',
        noBg: true,
        isExternal: true,
        newTab: true
      }
    },
    {
      path: `${onlineUrl}/get-supplier-user-preference`,
      name: 'user-preference',
      component: ()=> import('@/views/otherUrlView.vue'),
      meta: {
        title: '偏好设置',
        noBg: true,
        isExternal: true,
        newTab: true
      }
    },
    {
      path: "/cost-center/my-order",
      name: "const-center-my-order",
      component: () => import("@/views/cost-center/my-order.vue"),
      meta: {
        title: '购买记录',
        noBg: true,
      },
    },
    {
      path: "/cost-center/order-submission",
      name: "const-center-order-submission",
      component: () => import("@/views/cost-center/order-submission.vue"),
      meta: {
        title: "提交订单",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/order-payment/:orderNo",
      name: "const-center-order-payment",
      component: () => import("@/views/cost-center/order-payment.vue"),
      meta: {
        title: "支付订单",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/wx-payment/:orderNo",
      name: "const-center-wx-payment",
      component: () => import("@/views/cost-center/wx-payment.vue"),
      meta: {
        title: "微信支付",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/zfb-payment/:orderNo",
      name: "const-center-zfb-payment",
      component: () => import("@/views/cost-center/zfb-payment.vue"),
      meta: {
        title: "支付宝支付",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/meal-choose",
      name: "const-center-meal-choose",
      component: () => import("@/views/cost-center/meal-choose.vue"),
      meta: {
        title: "选购套餐",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/payment-success/:orderNo",
      name: "const-center-payment-success",
      component: () => import("@/views/cost-center/payment-success.vue"),
      meta: {
        title: "支付成功",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/public-success",
      name: "const-center-public-success",
      component: () => import("@/views/cost-center/public-success.vue"),
      meta: {
        title: "对公打款凭证已提交，待财务确认到账！",
        noBg: true,
        noNav: true,
        unMenu: true,
      },
    },
    {
      path: "/cost-center/real-success",
      name: "const-center-real-success",
      component: () => import("@/views/cost-center/real-success.vue"),
      meta: {
        title: "实名认证成功",
        newTab: true,
        keepAlive: false,
        disableScroll: false,
        broadcast: false,
        unMenu: true,
        noNav: true,
        noBg: true,
      },
    },
    // 平台发票
    {
      path: "/cost-center/my-invoice",
      name: "const-center-my-invoice",
      component: () => import("@/views/invoice/my-invoice.vue"),
      meta: {
        title: '平台发票',
        noBg: true,
      },
    },
    // record
    {
      path: "/cost-center/invoice-record",
      name: "const-center-invoice-record",
      component: () => import("@/views/invoice/invoice-record.vue"),
      meta: {
        title: '平台发票',
        noBg: true,
        unMenu: true,
        activeMenu: "const-center-my-invoice",
      },
    },
    // 发票详情
    {
      path: "/cost-center/invoice-detail",
      name: "const-center-invoice-detail",
      component: () => import("@/views/invoice/invoice-detail.vue"),
      meta: {
        title: "发票详情",
        noBg: true,
        unMenu: true,
        activeMenu: "const-center-my-invoice",
      },
    },
    // 平台合同
    {
      // https://pre-online.haizol.com/supplier/invoice/list
      // path: `${onlineUrl}/supplier/invoice/list`,
      path: `${onlineUrl}/purchase-order/supplier/administration/platformContract`,
      name: "platformContract",
      component: () => import("@/views/otherUrlView.vue"),
      meta: {
        title: '平台合同',
        noBg: true,
        isExternal: true,
        newTab: true,
      },
    },
    // {
    //   path: `${onlineUrl}/purchase-order/supplier/account/user-account-manage`,
    //   name: "supplier-user-account-manage",
    //   meta: {
    //     title: "账号管理",
    //     isExternal: true,
    //   },
    //   children:[
    //     {
    //       path: `${onlineUrl}/purchase-order/supplier/account/user-account-manage`,
    //       name: "supplier-user-account-manage",
    //       meta: {
    //         title: "用户管理",
    //         isExternal: true,
    //         noBg: true,
    //       },
    //     },
    //     {
    //       path: `${onlineUrl}/purchase-order/supplier/account/user-group-manage`,
    //       name: "supplier-user-group-manage",
    //       meta: {
    //         title: "用户组管理",
    //         isExternal: true,
    //         noBg: true,
    //       },
    //     },
    //     {
    //       path: `${onlineUrl}/purchase-order/supplier/account/role-permission-manage`,
    //       name: "supplier-role-permission-manage",
    //       meta: {
    //         title: "角色管理",
    //         isExternal: true,
    //         noBg: true,
    //       },
    //     },
    //   ]
    // },
  ]
}
